import { useMemo } from 'react'
import { PromoteFlag, RecommendFlag, Wrapper } from './styled'

interface ChannelButtonProps {
  data: {
    name: string
    discountRatio: number
    isRecommend?: boolean
    [key: string]: any
  }
  active?: boolean
  onClick?: () => void
  [key: string]: any
}

export default function ChannelButton({ data, active, onClick, ...props }: ChannelButtonProps) {
  const hasDiscount = useMemo(() => data.discountRatio > 0, [data])
  return (
    <Wrapper onClick={onClick} className={active ? 'active' : ''} {...props}>
      <span className="button-text">{data.name}</span>
      {hasDiscount && <PromoteFlag>送{data.discountRatio}%</PromoteFlag>}
      {data.isRecommend && <RecommendFlag>推</RecommendFlag>}
    </Wrapper>
  )
}
